import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginForm } from '../components/auth/LoginForm';

const searchSchema = z.object({ from: z.string().optional() });

export const Route = createFileRoute('/login/')({
    validateSearch: (s: Record<string, unknown>) => searchSchema.parse(s),
    component: LoginForm,
});
